import React, { useEffect, useState } from 'react';
import ListaPlanos from "../../components/ListaPlanos";
import { PlanoVinculadoEntidade, ProcessoBeneficioEntidade } from '../../entidades';
import { PlanoService, ProcessoBeneficioService } from '../../services';
import { Beneficio } from './Beneficio';
import { Box } from '@intech/web-ui';

import { MasterPage } from '../../components/MasterPage';
import ListaProcesso from '../../components/ListaProcesso';
import { NumFuncionalidade } from '../../helpers/BloqueioFuncionalidade';

export const ExtratoAssistido: React.FC = (props) => {
  const [Planos, setPlanos] = useState<PlanoVinculadoEntidade[]>([]);
  const [Plano, setPlano] = useState<PlanoVinculadoEntidade>(new PlanoVinculadoEntidade());
  const [CdPlano, setCdPlano] = useState("");
  const [beneficios, setBeneficios] = useState<ProcessoBeneficioEntidade[]>([]);
  const [beneficio, setBeneficio] = useState<ProcessoBeneficioEntidade | null>(null);
  const [beneficioSelecionado, setBeneficioSelecionado] = useState<string>("");

  useEffect(() => {
    (async () => {
      const planos = (await PlanoService.Buscar()).filter(x => x.CD_CATEGORIA === "4");
      const plano = planos[0];

      setPlanos(planos);
      setPlano(plano);
      setCdPlano(plano.CD_PLANO);

      const processosBeneficio = await ProcessoBeneficioService.BuscarPorPlano(
        plano.CD_PLANO
      );

      if (processosBeneficio.length > 0) {
        setBeneficios(processosBeneficio);
        setBeneficio(processosBeneficio[0]);
        setBeneficioSelecionado(processosBeneficio[0].DS_PROCESSO);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (CdPlano !== "") {
        const processosBeneficio = await ProcessoBeneficioService.BuscarPorPlano(
          CdPlano
        );
        if (processosBeneficio.length > 0) {
          setBeneficios(processosBeneficio);
          setBeneficio(processosBeneficio[0]);
          setBeneficioSelecionado(processosBeneficio[0].DS_PROCESSO);
        }
      }
    })();
  }, [CdPlano]);

  function handleSelecionarPlano(planoSelecionado: PlanoVinculadoEntidade) {
    if (CdPlano !== planoSelecionado.CD_PLANO) {
      setCdPlano(planoSelecionado.CD_PLANO);
    }
  }

  async function carregarProcesso(Processo: ProcessoBeneficioEntidade) {
    setBeneficio(Processo);
  }

  return (
    <MasterPage Funcionalidade={NumFuncionalidade.EXTRATO_DO_ASSISTIDO} {...props} >
      <Box>
        {/* <span className={"text-primary"}>
          {"Selecione um plano para visualizar o Extrato de Assistido"}
        </span> */}

        <ListaPlanos planos={Planos} cdPlanoAtivo={CdPlano} onChange={handleSelecionarPlano} />

        <ListaProcesso processos={beneficios} dsProcessoAtivo={beneficio?.DS_PROCESSO!} onChange={carregarProcesso} textoInstrucao={"Selecione um Processo para visualizar o Extrato de Assistido"} />

      </Box>

      {beneficio &&
        <Beneficio beneficio={beneficio} />
      }

    </MasterPage>
  );
}